import { Text } from '@ps-design-system/components/Text';
import { TextareaField } from '@ps-design-system/components/Textarea';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { HostAvatar } from './HostAvatar';

export const HostMessageSection = ({ hostAvatarUrl, hostFirstName, disabled, intl }) => {
  return (
    <>
      <Text typeface="headline-3-b" element="h3" style={{ margin: 0 }}>
        <FormattedMessage
          id="booking_details_form.your_host"
          defaultMessage="Your host"
        />
      </Text>
      <div style={{ marginTop: '24px' }}>
        <HostAvatar
          hostAvatarUrl={hostAvatarUrl}
          hostFirstName={hostFirstName}
          isPowerHost={false} // @TODO: where to get this value from?
        />
      </div>
      <div style={{ marginTop: '24px' }}>
        <TextareaField
          testId="host-message-textarea"
          name="message"
          className="tw-min-w-[320px]"
          fullWidth={true}
          placeholder={intl.formatMessage(
            {
              id: 'booking_details_form.introduce_yourself',
              defaultMessage:
                "Introduce yourself and let {hostFirstName} know what you're planning."
            },
            { hostFirstName }
          )}
          disabled={disabled}
        />
      </div>
    </>
  );
};

HostMessageSection.displayName = 'HostMessageSection';
HostMessageSection.propTypes = {
  hostAvatarUrl: PropTypes.string,
  hostFirstName: PropTypes.string,
  intl: PropTypes.object
};
